import PropTypes from 'prop-types';

import JsonLd from 'Components/Jsonld';

const node2Text = answer => {
  if (typeof answer === 'string') {
    return answer;
  }
  return answer?.props?.children.reduce((acc, child) => {
    if (typeof child === 'string') {
      return acc.concat(child);
    }
    if (child.type === 'br') {
      return acc.concat('\n');
    }
    // We don't handle something else atm.
    return acc;
  }, '');
};

const ensureIsText = ({ rawQuestion, question }) => {
  if (rawQuestion && typeof rawQuestion === 'string') {
    return rawQuestion;
  }
  if (typeof question !== 'string') {
    throw new Error(`question ${question} should be a string`);
  }
  return question;
};

const JsonldForFaq = ({ questions }) => (
  <JsonLd>
    {{
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: questions.map(({ rawQuestion, question, answer }) => ({
        '@type': 'Question',
        name: ensureIsText({ rawQuestion, question }),
        acceptedAnswer: {
          '@type': 'Answer',
          text: node2Text(answer),
        },
      })),
    }}
  </JsonLd>
);

JsonldForFaq.propTypes = {
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      // it is important that both fields are strings otherwise google will not crawld the page
      question: PropTypes.node.isRequired,
      rawQuestion: PropTypes.string,
      answer: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    })
  ).isRequired,
};

export default JsonldForFaq;
